angular.module('smartorg.r6.mgmts.createPortfolioFrom').directive('createPortfolioFromExisting', ["terminologyService", function (terminologyService) {
        return {
            restrict: 'E',
            template: require('../../template/create-portfolio-from-existing.html'),
            scope: {
                createPortfolioFromExisting: '&',
                terminology: '=?'
            },
            link: function (scope) {
                // Initialize terminology with defaults if not provided
                if (!scope.terminology) {
                    scope.terminology = terminologyService.getDefaultTerminology();
                }
                scope.selected = {
                    'acl': true,
                    'categoriesConfig': true,
                    'univSchema': true
                };
                scope.$on('manage:CreatePortfolioFromExisting', function (event, args) {
                    scope.categoriesConfig = args.categoriesConfig;
                    scope.acl = args.acl;
                    scope.univSchema = args.univSchema;
                    scope.portfolioName = args.treeID;
                    scope.dirty = false;
                    scope.origPortfolioName = angular.copy(args.treeID);
                    $('#createPortfolioFromExistingModal').modal('show');
                });
                scope.saveNewPortfolio = function () {
                    if (scope.categoriesConfig == undefined) {
                        scope.categoriesConfig = null;
                    }
                    if (scope.univSchema == undefined) {
                        scope.univSchema = null;
                    }
                    scope.createPortfolioFromExisting({
                        newPortfolioName: scope.portfolioName,
                        categoriesConfig: scope.selected['categoriesConfig'] ?
                            scope.categoriesConfig : null,
                        acl: scope.selected['acl'] ? scope.acl : null,
                        univSchema: scope.selected['univSchema'] ? scope.univSchema : null
                    });
                    scope.resetPortfolio();
                };
                scope.checkDirty = function () {
                    scope.dirty = !(scope.portfolioName == '' ||
                        scope.portfolioName == scope.origPortfolioName);
                };
                scope.resetPortfolio = function () {
                    scope.portfolioName = scope.origPortfolioName;
                };
            }
        };
    }]);
//# sourceMappingURL=create-portfolio-from-existing-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/create-portfolio-from-existing/app/js/plumbing/create-portfolio-from-existing-directive.js